import { CursosService } from './../../services/cursos.service';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { ClasesService } from '../../services/clases.service';
import { Clases } from '../../interfaces/clases';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-misgrupos',
  templateUrl: './misgrupos.component.html',
  styleUrls: ['./misgrupos.component.css']
})
export class MisgruposComponent implements OnInit {
  userdata: any;
  misclases = [];
  userUid: any;
  clase: Clases;
  clasecontador: number;
  searchValue: string;
  clicked = false;
  borrar : boolean = false;
  uidBorrar: string ="";

  constructor(private authenticationService: AuthenticationService,
              private userService: UserService,
              private cursosService: CursosService,
              private clasesService: ClasesService) { }

  ngOnInit(): void {
    const Userdata: any = this.userService.getUserinfodata();

    if (Userdata === undefined) {
      this.getmainuserdata();
    } else {
      this.misclases = [];
      this.userUid = Userdata.payload.doc.data().uid; /* id del usuario */
      this.userdata = Userdata.payload.doc.data();
      this.getClases(this.userdata); /* llama a la funcion para obtener las clases del usuario */
    }
  }

  /* trae informacion principal del usuario logueado */
  getmainuserdata() {
    this.authenticationService.isAuth().subscribe(auth =>{
      if(auth) {
        this.userUid = auth.uid; /* id del usuario */

        this.authenticationService.isUserAdmin(this.userUid).subscribe(userdata => {
          if(userdata[0]){

            this.userdata = userdata[0];
            this.misclases = [];
            this.getClases(this.userdata); /* llama a la funcion para obtener las clases del usuario */
          }
        });

      }
    });
  }


  /* obtiene las clases al que pertenezca el usuario logueado */
  getClases(userdata) {

    if (userdata?.classes?.[0]) {

      this.misclases = [];
      userdata.classes.forEach((clase: any) => {

        this.clasesService.getClaseByIdNow(clase).subscribe(laclase => {
          if (laclase) {

            this.clase = laclase.data();

            this.misclases.push({
              uid: clase,
              admins: this.clase.admins,
              course: this.clase.course,
              name: this.clase.name,
              imagen: this.clase.imagen,
              users: this.clase.users,
            });

            this.clasecontador = this.misclases.length;
          }
        });

      });

    }

  }


  DeleteClass(classuid) {
    console.log(classuid);

    let searchusersbyclass = this.userService.getUsersbyClass(classuid).subscribe(resulusers => {
      if(resulusers) {
        resulusers.forEach((eluser) => {
          this.userService.removeUserFromClass(eluser.payload.doc.id, classuid).then((edit) => {
            console.log(edit);
            this.uidBorrar="";
         
          }).catch((error) => {console.log(error)});
        });
      }
      searchusersbyclass.unsubscribe();
    });

    let searchcursosbyclass = this.cursosService.getCursosByClassid(classuid).subscribe(resulcurso => {
      if(resulcurso) {
        resulcurso.forEach((elcurso) => {
          this.cursosService.removeClassFromCourse(elcurso.payload.doc.id, classuid).then((edit) => {
            console.log(edit);
          }).catch((error) => {console.log(error)});
        });
      }
      searchcursosbyclass.unsubscribe();
    });

    this.clasesService.DeleteClass(classuid).then(respondel => {
      this.clicked = false;
    });

  }

  borrarPop(classuid){
    this.uidBorrar? this.uidBorrar="" :this.uidBorrar= classuid;
  }

}
